import { useEffect } from "react";
import { awsRum } from "../../..";
import { RUMPage } from "../../../enums/rum";
import AgencyAdminGrid from "../../../components/admin/agencies";

const AgencyAdminPage = () => {
  useEffect(() => {
    try{
      awsRum.recordPageView(RUMPage.ADMIN);
    }
    catch{
      // Swallow rum errors
    }
    
  }, [])
  
  return <AgencyAdminGrid />;
};

export default AgencyAdminPage;
